import React__default from 'react';
import classes from './index.module.scss.js';

const ActivePromotionRibbon = ({ children, }) => React__default.createElement("span", { className: `${classes.ribbon} caption` }, children);

export { ActivePromotionRibbon };
//# sourceMappingURL=index.js.map
